/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S6_Li3Inputs */

const en_guide_what_is_json_s6_li3 = /** @type {(inputs: Guide_What_Is_Json_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use <strong>consistent naming conventions</strong>: camelCase is most common in JSON APIs`)
};

const ko_guide_what_is_json_s6_li3 = /** @type {(inputs: Guide_What_Is_Json_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>일관된 명명 규칙</strong>을 사용하세요: camelCase가 JSON API에서 가장 일반적입니다`)
};

const ja_guide_what_is_json_s6_li3 = /** @type {(inputs: Guide_What_Is_Json_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>一貫した命名規則</strong>を使用してください: camelCaseがJSON APIで最も一般的です`)
};

/**
* | output |
* | --- |
* | "Use <strong>consistent naming conventions</strong>: camelCase is most common in JSON APIs" |
*
* @param {Guide_What_Is_Json_S6_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s6_li3 = /** @type {((inputs?: Guide_What_Is_Json_S6_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S6_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s6_li3(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s6_li3(inputs)
	return ja_guide_what_is_json_s6_li3(inputs)
});